module.exports = __webpack_public_path__ + "img/arrecredihome3v_dv_r3.fb484dbd.webp";